// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PricedOrderItems_priced-order-items__yBNF5 {
  max-width: 116rem;
  margin: 7rem auto;
}

.PricedOrderItems_priced-order-items__loading__L5xFQ {
  margin: 10rem auto;
  width: 10rem;
  height: 10rem;
}

.PricedOrderItems_priced-order-items__empty__CbWZt {
  margin-top: 10rem;
}

.PricedOrderItems_priced-order-items__empty__CbWZt .icon-wrapper {
  padding: 2rem;
}

.PricedOrderItems_priced-order-items__empty__CbWZt .icon {
  width: 6rem;
  height: 6rem;
}

.PricedOrderItems_prices-table__item-name__clIfy {
  font-size: var(--text-base);
  font-weight: 500;
  position: relative;
}

.PricedOrderItems_prices-table__price-list__vFxoi {
  padding-inline-start: 5rem;
  margin-bottom: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.PricedOrderItems_prices-table__reject-btn__AF7lr {
  display: block;
  padding: 1.6rem 6rem;
  width: -moz-fit-content;
  width: fit-content;
  margin-inline-start: auto;
}

.PricedOrderItems_prices-table__error-txt__g5Yda {
  padding-inline-start: 5rem;
  color: var(--danger);
  font-size: var(--text-base);
  font-weight: 500;
}

.PricedOrderItems_prices-table__reject-wrapper__midC9 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;
}

.PricedOrderItems_priced-order-items__submit-prices-wrapper__tgJgu {
  margin-top: 7rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: flex-end;
}

.PricedOrderItems_priced-order-items__primary-btn__JeGg4 {
  padding: 1.2rem 5rem 1.2rem 3rem;
  gap: 6rem;
}

.PricedOrderItems_priced-order-items__primary-btn--loading__J8He9 {
  padding: 1.2rem 6rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/PricedOrders/PricedOrderListItem/PricedOrderItems/PricedOrderItems.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,uBAAkB;EAAlB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".priced-order-items {\n  max-width: 116rem;\n  margin: 7rem auto;\n}\n\n.priced-order-items__loading {\n  margin: 10rem auto;\n  width: 10rem;\n  height: 10rem;\n}\n\n.priced-order-items__empty {\n  margin-top: 10rem;\n}\n\n.priced-order-items__empty :global(.icon-wrapper) {\n  padding: 2rem;\n}\n\n.priced-order-items__empty :global(.icon) {\n  width: 6rem;\n  height: 6rem;\n}\n\n.prices-table__item-name {\n  font-size: var(--text-base);\n  font-weight: 500;\n  position: relative;\n}\n\n.prices-table__price-list {\n  padding-inline-start: 5rem;\n  margin-bottom: 2.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n}\n\n.prices-table__reject-btn {\n  display: block;\n  padding: 1.6rem 6rem;\n  width: fit-content;\n  margin-inline-start: auto;\n}\n\n.prices-table__error-txt {\n  padding-inline-start: 5rem;\n  color: var(--danger);\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.prices-table__reject-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.2rem;\n}\n\n.priced-order-items__submit-prices-wrapper {\n  margin-top: 7rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  align-items: flex-end;\n}\n\n.priced-order-items__primary-btn {\n  padding: 1.2rem 5rem 1.2rem 3rem;\n  gap: 6rem;\n}\n\n.priced-order-items__primary-btn--loading {\n  padding: 1.2rem 6rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"priced-order-items": `PricedOrderItems_priced-order-items__yBNF5`,
	"priced-order-items__loading": `PricedOrderItems_priced-order-items__loading__L5xFQ`,
	"priced-order-items__empty": `PricedOrderItems_priced-order-items__empty__CbWZt`,
	"prices-table__item-name": `PricedOrderItems_prices-table__item-name__clIfy`,
	"prices-table__price-list": `PricedOrderItems_prices-table__price-list__vFxoi`,
	"prices-table__reject-btn": `PricedOrderItems_prices-table__reject-btn__AF7lr`,
	"prices-table__error-txt": `PricedOrderItems_prices-table__error-txt__g5Yda`,
	"prices-table__reject-wrapper": `PricedOrderItems_prices-table__reject-wrapper__midC9`,
	"priced-order-items__submit-prices-wrapper": `PricedOrderItems_priced-order-items__submit-prices-wrapper__tgJgu`,
	"priced-order-items__primary-btn": `PricedOrderItems_priced-order-items__primary-btn__JeGg4`,
	"priced-order-items__primary-btn--loading": `PricedOrderItems_priced-order-items__primary-btn--loading__J8He9`
};
export default ___CSS_LOADER_EXPORT___;
